<template>
  <tr class="">
    <th
      scope="row"
      class="px-4 py-4 text-sm font-normal text-gray-400 border-b border-r"
      :class="isHorizontalLayout ? 'w-1/6' : 'w-1/2'">
      {{ name }}
    </th>
    <td :class="mode == 'view' ? 'border-b ' : 'no-border py-1'">
      <div
        class="w-full px-4 text-sm text-gray-500"
        :class="[
          isHorizontalLayout && mode == 'edit' ? 'lg:w-2/3' : '',
          price ? 'text-right' : '',
        ]">
        <slot />
      </div>
    </td>
  </tr>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    name: string;
    mode: string;
    isHorizontalLayout?: boolean;
    price?: boolean;
  }>(),
  {
    isHorizontalLayout: false,
  }
);
</script>
